import { type JsonDataItem } from '@g2u/ui-kit';
import { baseQuery } from '../baseQuery';

export const getCustomerNotes = async ({ queryKey }: JsonDataItem) => {
  const { id, page = 1, per_page = 10 } = queryKey[1];

  const queryParams = new URLSearchParams();

  queryParams.append('customer_id', id);
  queryParams.append('per_page', per_page.toString());
  queryParams.append('page', page.toString());

  const { data, meta } = await baseQuery(`customer-notes?${queryParams.toString()}`);

  return { data, meta };
};
